import api from '../api/api';
import useStore from '../store/store';

const ResendConfirmationCode = async (iso2 = undefined, phone = undefined) => {
    const setFormError = useStore.getState().setFormError;
    const setLoading = useStore.getState().setLoading;

    setLoading(true);
    setFormError(null);

    try {
        const response = await api.post('/security/resend-confirmation-code', {
            iso2,
            phone,
        });
        const { success, errCode } = response.data;

        if (success) {
            setLoading(false);
            console.info('Confirmation code resent.');
        } else if (!success && errCode) {
            setLoading(false);
            setFormError(errCode);
        }
    } catch (e) {
        console.error(e);
        // Network Error (error code 17)
        if (e.code) setFormError(e.code);
    }
};

export default ResendConfirmationCode;
